/* =============================================================================
   IT GIRL GLOWVERSE
   Cart interactions, cart drawer, sign-in portal, sign-out farewell.

   Rules this file holds itself to:
   - Every cart write goes through Shopify's own /cart/*.js endpoints.
   - Every piece of HTML it puts on the page is rendered by Shopify through the
     Section Rendering API, never built here, so prices and discounts can never
     drift from the real cart.
   - It is an enhancement. Remove this file and every control falls back to the
     plain links and form posts underneath it.
   ============================================================================= */
(function () {
  'use strict';

  var D = document;
  var root = D.documentElement;
  // Section ids come from Liquid at render time. A JSON-template section is not
  // called "main-cart" in the DOM, it is "template--<id>__main-cart", so never guess it.
  function secId(sel, fallback) {
    var el = D.querySelector(sel);
    var v = el && el.getAttribute('data-gv-section');
    return v || fallback || null;
  }
  var internal = false;          // true while we are the ones calling /cart/add
  var busy = false;
  var pending = {};              // line index -> target quantity, for debounced steppers
  var timer = null;
  var lastRemoved = null;
  var undoEl = null;
  var undoTimer = null;

  function $(sel, ctx) { return (ctx || D).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || D).querySelectorAll(sel)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt || false); }

  function sectionsWanted() {
    var list = [];
    var d = secId('[data-gv-drawer]', 'cart-drawer');
    if (d) list.push(d);
    var c = secId('[data-gv-cart]', null);
    if (c) list.push(c);
    return list.join(',');
  }

  /* --------------------------------------------------------------------------
     Swapping rendered sections back in
     -------------------------------------------------------------------------- */
  function swapSection(id, html) {
    var host = D.getElementById('shopify-section-' + id);
    if (!host || !html) return;
    var parsed;
    try {
      parsed = new DOMParser().parseFromString(html, 'text/html');
    } catch (e) { return; }
    var fresh = parsed.getElementById('shopify-section-' + id);
    host.innerHTML = fresh ? fresh.innerHTML : html;
  }

  function applySections(sections) {
    if (!sections) return;
    var drawer = getDrawer();
    var wasOpen = !!(drawer && drawer.classList.contains('is-open'));
    var scrollTop = 0;
    if (wasOpen) {
      var body = $('.gv-dr__body', drawer);
      if (body) scrollTop = body.scrollTop;
    }

    Object.keys(sections).forEach(function (id) { swapSection(id, sections[id]); });

    if (wasOpen) {
      var d2 = getDrawer();
      if (d2) {
        d2.classList.add('gv-nofx', 'is-open');
        var b2 = $('.gv-dr__body', d2);
        if (b2 && scrollTop) b2.scrollTop = scrollTop;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { d2.classList.remove('gv-nofx'); });
        });
      }
    }
    refreshCount();
    initBar();
  }

  function refreshCount() {
    var drawer = getDrawer();
    var n = drawer ? parseInt(drawer.getAttribute('data-gv-count') || '0', 10) : null;
    if (n === null || isNaN(n)) return;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  /* --------------------------------------------------------------------------
     Cart writes
     -------------------------------------------------------------------------- */
  function cartPost(url, payload) {
    payload.sections = sectionsWanted();
    payload.sections_url = window.location.pathname;
    internal = true;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        internal = false;
        if (res.ok && res.data && res.data.sections) applySections(res.data.sections);
        return res;
      })
      .catch(function (err) { internal = false; throw err; });
  }

  function flushQuantities() {
    var keys = Object.keys(pending);
    if (!keys.length || busy) return;
    var line = keys[0];
    var qty = pending[line];
    delete pending[line];
    busy = true;
    cartPost('/cart/change.js', { line: parseInt(line, 10), quantity: qty })
      .then(function () { busy = false; flushQuantities(); })
      .catch(function () { busy = false; window.location.href = '/cart'; });
  }

  function queueQuantity(line, qty, valEl) {
    pending[line] = qty;
    if (valEl) {
      valEl.textContent = qty;
      valEl.classList.remove('is-pulse');
      void valEl.offsetWidth;
      valEl.classList.add('is-pulse');
    }
    clearTimeout(timer);
    timer = setTimeout(flushQuantities, 260);
  }

  /* --------------------------------------------------------------------------
     Undo
     -------------------------------------------------------------------------- */
  function buildUndo() {
    if (undoEl) return undoEl;
    undoEl = D.createElement('div');
    undoEl.className = 'gv-undo';
    undoEl.setAttribute('role', 'status');
    undoEl.innerHTML = '<span></span><button type="button">Undo</button>';
    D.body.appendChild(undoEl);
    on($('button', undoEl), 'click', function () {
      if (!lastRemoved) return;
      var item = lastRemoved;
      lastRemoved = null;
      hideUndo();
      var payload = { items: [{ id: item.variantId, quantity: item.quantity }] };
      if (item.sellingPlan) payload.items[0].selling_plan = item.sellingPlan;
      if (item.properties) payload.items[0].properties = item.properties;
      cartPost('/cart/add.js', payload).catch(function () { window.location.href = '/cart'; });
    });
    return undoEl;
  }

  function showUndo(title) {
    var el = buildUndo();
    $('span', el).textContent = title + ' removed';
    el.classList.add('is-on');
    clearTimeout(undoTimer);
    undoTimer = setTimeout(hideUndo, 7000);
  }
  function hideUndo() {
    if (undoEl) undoEl.classList.remove('is-on');
    clearTimeout(undoTimer);
  }

  function removeLine(lineEl, index, title) {
    // Remember enough to put it back exactly as it was.
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var it = cart.items[index - 1];
        if (it) {
          lastRemoved = {
            variantId: it.variant_id,
            quantity: it.quantity,
            sellingPlan: it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.id : null,
            properties: it.properties && Object.keys(it.properties).length ? it.properties : null
          };
        }
      })
      .catch(function () { lastRemoved = null; })
      .then(function () {
        if (lineEl) lineEl.classList.add('is-going');
        return cartPost('/cart/change.js', { line: index, quantity: 0 });
      })
      .then(function () { if (lastRemoved) showUndo(title || 'Item'); })
      .catch(function () { window.location.href = '/cart'; });
  }

  /* --------------------------------------------------------------------------
     Delegated clicks
     -------------------------------------------------------------------------- */
  on(D, 'click', function (e) {
    var t = e.target;

    var step = t.closest ? t.closest('[data-gv-qty]') : null;
    if (step) {
      e.preventDefault();
      var line = parseInt(step.getAttribute('data-gv-index'), 10);
      var qty = parseInt(step.getAttribute('data-gv-qty'), 10);
      var wrap = step.closest('.gv-step');
      var valEl = wrap ? $('[data-gv-val]', wrap) : null;
      var lineEl = step.closest('.gv-line');
      if (qty <= 0) {
        removeLine(lineEl, line, lineEl && lineEl.getAttribute('data-gv-title'));
      } else {
        // Keep both arrows pointing at the right next value while taps stack up.
        if (wrap) {
          var arrows = $$('[data-gv-qty]', wrap);
          if (arrows[0]) arrows[0].setAttribute('data-gv-qty', Math.max(0, qty - 1));
          if (arrows[1]) arrows[1].setAttribute('data-gv-qty', qty + 1);
        }
        queueQuantity(line, qty, valEl);
      }
      return;
    }

    var rm = t.closest ? t.closest('[data-gv-remove]') : null;
    if (rm) {
      e.preventDefault();
      var li = rm.closest('.gv-line');
      removeLine(li, parseInt(rm.getAttribute('data-gv-index'), 10), li && li.getAttribute('data-gv-title'));
      return;
    }

    var add = t.closest ? t.closest('[data-gv-add]') : null;
    if (add) {
      e.preventDefault();
      var id = add.getAttribute('data-gv-add');
      if (!id || add.disabled) return;
      var label = add.textContent;
      add.disabled = true;
      add.textContent = 'Adding';
      cartPost('/cart/add.js', { items: [{ id: parseInt(id, 10), quantity: 1 }] })
        .then(function (res) {
          if (res && res.ok) { openDrawer(); }
          else { add.disabled = false; add.textContent = label; }
        })
        .catch(function () { add.disabled = false; add.textContent = label; });
      return;
    }

    var close = t.closest ? t.closest('[data-gv-close]') : null;
    if (close) { e.preventDefault(); closeDrawer(); return; }

    // Header cart icon opens the drawer instead of leaving the page.
    var cartLink = t.closest ? t.closest('a[href$="/cart"], a[href*="/cart?"], a[href="/cart"]') : null;
    if (cartLink && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
      if (cartLink.closest('.gv-dr__foot') || cartLink.hasAttribute('data-gv-nodrawer')) return;
      if (D.body.classList.contains('template-cart')) return;
      if (!getDrawer()) return;
      e.preventDefault();
      openDrawer();
      return;
    }

    // Sign-in: play the portal, then hand straight over to Shopify's real sign-in.
    var acct = t.closest ? t.closest('a[href*="/account"], a[href*="shopify.com/"][href*="/account"]') : null;
    if (acct && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0 && !D.body.getAttribute('data-gv-in-progress')) {
      if (root.classList.contains('gv-noportal')) return;
      var href = acct.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      e.preventDefault();
      portalTo(acct.href);
      return;
    }
  }, false);

  /* --------------------------------------------------------------------------
     Add to cart without leaving the page.
     Falls straight back to the normal form post on anything unexpected, and
     stands aside the moment another script has already handled the submit.
     -------------------------------------------------------------------------- */
  on(D, 'submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented) return;                       // someone else owns this submit
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (form.hasAttribute('data-gv-skip')) return;         // our own fallback submit
    if (form.querySelector('input[type="file"]')) return;  // never touch uploads
    if (!getDrawer()) return;

    e.preventDefault();
    var btn = form.querySelector('[type="submit"]') || form.querySelector('button:not([type="button"])');
    var label = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    var restore = function () {
      if (!btn) return;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      if (label !== null) btn.innerHTML = label;
    };
    var fallback = function () {
      restore();
      form.setAttribute('data-gv-skip', '1');
      form.submit();
    };

    var fd = new FormData(form);
    fd.append('sections', sectionsWanted());
    fd.append('sections_url', window.location.pathname);
    internal = true;
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        internal = false;
        if (!res.ok) { fallback(); return; }
        restore();
        if (res.data && res.data.sections) { applySections(res.data.sections); openDrawer(); }
        else { afterForeignAdd(); }
      })
      .catch(function () { internal = false; fallback(); });
  }, false);

  /* --------------------------------------------------------------------------
     Drawer
     -------------------------------------------------------------------------- */
  function getDrawer() { return D.getElementById('gv-drawer'); }
  var lastFocus = null;

  function openDrawer() {
    var dr = getDrawer();
    if (!dr) { window.location.href = '/cart'; return; }
    lastFocus = D.activeElement;
    dr.classList.add('is-open');
    root.classList.add('gv-locked');
    D.body.classList.add('gv-locked');
    var panel = $('.gv-dr__panel', dr);
    window.setTimeout(function () {
      var first = $('.gv-dr__x', dr);
      if (first) first.focus();
    }, 60);
    if (panel) panel.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    var dr = getDrawer();
    if (!dr) return;
    dr.classList.remove('is-open');
    root.classList.remove('gv-locked');
    D.body.classList.remove('gv-locked');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  on(D, 'keydown', function (e) {
    var dr = getDrawer();
    if (!dr || !dr.classList.contains('is-open')) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var focusables = $$('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])', dr)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (e.shiftKey && D.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && D.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* --------------------------------------------------------------------------
     Notice something else added to the cart, without touching how it was added
     -------------------------------------------------------------------------- */
  function afterForeignAdd() {
    if (!getDrawer()) return;
    fetch('?sections=' + secId('[data-gv-drawer]', 'cart-drawer'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (secs) { applySections(secs); openDrawer(); })
      .catch(function () {});
  }

  try {
    var origFetch = window.fetch;
    if (typeof origFetch === 'function') {
      window.fetch = function () {
        var args = arguments;
        var p = origFetch.apply(this, args);
        try {
          var u = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
          if (!internal && /\/cart\/add(\.js)?(\?|$)/.test(u)) {
            p.then(function (r) { if (r && r.ok) setTimeout(afterForeignAdd, 90); }).catch(function () {});
          }
        } catch (e) {}
        return p;
      };
    }
    var origSend = XMLHttpRequest.prototype.send;
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      try { this.__gvUrl = u; } catch (e) {}
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      try {
        var self = this;
        if (!internal && /\/cart\/add(\.js)?(\?|$)/.test(self.__gvUrl || '')) {
          self.addEventListener('load', function () {
            if (self.status >= 200 && self.status < 300) setTimeout(afterForeignAdd, 90);
          });
        }
      } catch (e) {}
      return origSend.apply(this, arguments);
    };
  } catch (e) {}

  /* --------------------------------------------------------------------------
     Mobile sticky checkout bar
     -------------------------------------------------------------------------- */
  var barObserver = null;
  function initBar() {
    var bar = $('[data-gv-bar]');
    var anchor = $('.gv-panel .gv-cta');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    if (barObserver) barObserver.disconnect();
    barObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0 });
    barObserver.observe(anchor);
  }

  /* --------------------------------------------------------------------------
     Glowverse portal, used for the hand-off to Shopify's sign-in
     -------------------------------------------------------------------------- */
  function portalTo(url) {
    var fx = D.createElement('div');
    fx.className = 'gv-fx';
    fx.setAttribute('aria-hidden', 'true');
    fx.innerHTML =
      '<span class="gv-fx__ring"></span><span class="gv-fx__ring"></span><span class="gv-fx__ring"></span>' +
      '<div class="gv-fx__w"><b>Entering the Glowverse</b><span>One moment</span></div>';
    D.body.appendChild(fx);
    D.body.setAttribute('data-gv-in-progress', '1');
    requestAnimationFrame(function () { fx.classList.add('is-on'); });
    var went = false;
    var go = function () { if (went) return; went = true; window.location.href = url; };
    setTimeout(go, 430);
    setTimeout(go, 1600); // safety net
  }

  /* --------------------------------------------------------------------------
     Signed in / signed out moments
     -------------------------------------------------------------------------- */
  function note(kicker, title, text, ctaText, ctaHref, dismissText) {
    var el = D.createElement('div');
    el.className = 'gv-note';
    el.setAttribute('role', 'status');
    var row = '<a class="gv-note__a" href="' + ctaHref + '">' + ctaText + '</a>' +
      '<button type="button" class="gv-note__b">' + dismissText + '</button>';
    el.innerHTML =
      '<p class="gv-note__k"><i aria-hidden="true"></i>' + kicker + '</p>' +
      '<p class="gv-note__t">' + title + '</p>' +
      '<p class="gv-note__d">' + text + '</p>' +
      '<div class="gv-note__row">' + row + '</div>';
    D.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-on'); });
    var hide = function () {
      el.classList.remove('is-on');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 600);
    };
    on($('.gv-note__b', el), 'click', hide);
    setTimeout(hide, 13000);
  }

  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
  }); }

  function accountMoments() {
    var body = D.body;
    var signedIn = body.getAttribute('data-gv-in') === '1';
    var name = body.getAttribute('data-gv-name') || '';
    var key = 'gv_was_in';
    var was = null;
    try { was = sessionStorage.getItem(key); } catch (e) { return; }

    if (signedIn) {
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
      if (was !== '1') {
        note('Welcome back', name ? 'Hi ' + esc(name) : 'You are in',
          'Your glow box, your orders and your details are all where you left them.',
          'Keep shopping', '/collections/it-girl-vitamins', 'Close');
      }
      return;
    }

    if (was === '1') {
      try { sessionStorage.removeItem(key); } catch (e) {}
      note('Signed out', 'See you soon',
        'You are signed out. Your glow box is still saved on this device, so nothing is lost.',
        'Back to shopping', '/collections/it-girl-vitamins', 'Stay here');
    }
  }

  /* --------------------------------------------------------------------------
     Boot
     -------------------------------------------------------------------------- */
  function boot() {
    initBar();
    refreshCount();
    accountMoments();
  }
  if (D.readyState === 'loading') on(D, 'DOMContentLoaded', boot);
  else boot();
})();
